import { httpPost } from "utils/httpRequest";

/** Backend ApiErrorCode.Success.code (TransformInterceptor envelope). */
const RTN_SUCCESS = 200;

/**
 * Admin API returns { rtnCode, data, message }. Biz errors often use HTTP 200 + rtnCode !== 200.
 */
function unwrapAdminMarketplaceResponse(resp) {
  const body = resp?.data;
  if (body == null || typeof body !== "object") {
    return body;
  }
  if (body.rtnCode === RTN_SUCCESS) {
    return body.data;
  }
  const err = new Error(body.message || "Request failed");
  err.rtnCode = body.rtnCode;
  throw err;
}

const listMarketplaceCategories = async () => {
  const resp = await httpPost("admin/marketplace/category/list", {});
  return unwrapAdminMarketplaceResponse(resp) || [];
};

const addMarketplaceCategory = async (payload) => {
  const resp = await httpPost("admin/marketplace/category/add", payload);
  return unwrapAdminMarketplaceResponse(resp);
};

const editMarketplaceCategory = async (payload) => {
  const resp = await httpPost("admin/marketplace/category/edit", payload);
  return unwrapAdminMarketplaceResponse(resp);
};

const deleteMarketplaceCategory = async (id) => {
  const resp = await httpPost("admin/marketplace/category/delete", { id });
  return unwrapAdminMarketplaceResponse(resp);
};

const listMarketplaceProducts = async (filters = {}) => {
  const resp = await httpPost("admin/marketplace/product/list", filters);
  return unwrapAdminMarketplaceResponse(resp) || [];
};

const addMarketplaceProduct = async (payload) => {
  const resp = await httpPost("admin/marketplace/product/add", payload);
  return unwrapAdminMarketplaceResponse(resp);
};

const editMarketplaceProduct = async (payload) => {
  const resp = await httpPost("admin/marketplace/product/edit", payload);
  return unwrapAdminMarketplaceResponse(resp);
};

const deleteMarketplaceProduct = async (id) => {
  const resp = await httpPost("admin/marketplace/product/delete", { id });
  return unwrapAdminMarketplaceResponse(resp);
};

export {
  listMarketplaceCategories,
  addMarketplaceCategory,
  editMarketplaceCategory,
  deleteMarketplaceCategory,
  listMarketplaceProducts,
  addMarketplaceProduct,
  editMarketplaceProduct,
  deleteMarketplaceProduct,
};
